export default __webpack_public_path__ + "static/media/kamp.e238845c.jpg";